export type GridDomLayout = "autoHeight" | "normal" | "print";

export const GRID_DOM_LAYOUT = {
  AUTO_HEIGHT: "autoHeight" as GridDomLayout,
  NORMAL: "normal" as GridDomLayout,
  PRINT: "print" as GridDomLayout,
};
